import {EDIT_HIDE_FIELD, LAYOUT_TYPE, PAAS_REG, SEQUENCE_CODE_KEY_MAP} from '../../constants/index'
import { getTargetFlow } from '../global-api/target-stack'
import {getFieldRule} from '../rule'
import {assign, isBoolean} from 'lodash-es'
import {insetField} from '../store'
import {COMPONENTS_NAMES} from '../../constants/componet-names'
import { _initProps } from './index'

// PAAS_REG,
// 合并props
export default function processField (node, payload, parentPath) {
  const { fieldMap, layoutApiName, objectApiName, info, pageType, _codeApiNameRelation } = payload
  const _code = _codeApiNameRelation[node[SEQUENCE_CODE_KEY_MAP.TARGET_SEQ_CODE]]
  const fieldConfSection = node.fieldConf?.section || ''
  const field = assign(node, fieldMap[_code])
  field.fieldConfSection = fieldConfSection
  field.targetApiName = _code
  if (!field.type) {
    console.log(field, '==field===')
    console.error('失败')
    return
  }
  field._type = field.type?.replace(PAAS_REG, '')
  field.uniqueApiName = field.objectApiName
  field.objectApiName = objectApiName
  field.layoutApiName = layoutApiName
  field.tenantType = info.app
  field.fieldComponentName = COMPONENTS_NAMES[field.type]
  if (LAYOUT_TYPE.TARGET_TYPE_SUMMARY === getTargetFlow(2) || !parentPath) {
    summary(field, payload)
  } else if (LAYOUT_TYPE.TARGET_TYPE_FILTER === getTargetFlow(2)) {
    search(field, payload)
  } else {
    normal(field, payload, parentPath)
  }
  if (!field.props.hasOwnProperty('pageShow')) {
    field.props.pageShow = true
  }
  // 编辑页 自增编号和引用字段不展示
  if (pageType === 'edit' && EDIT_HIDE_FIELD.includes(field.type)) {
    field.props.pageShow = false
  }
  field.props.label = field.props?.label || field.name
  field.props.section = field.fieldConfSection
  field.props.hideLabel = field.props.hiddenName
  field.props.showTooltip = isBoolean(field.showTooltip) ? field.showTooltip : true
  if (isBoolean(field.showTooltip)) {
    field.props.removeLabel = true
  }
  return field
}

// 普通字段处理
function normal (field, {subObjectParamName, pageType, _id, objectApiName}, parentPath) {
  field.props = assign({required: field.required}, field.fieldConf, field.props)
  _initProps(field, field._type)
  field.__isUse = true
  field.parentKey = subObjectParamName
  field.props.labelTip = field.tip
  field.props.disabled = isBoolean(field.props.disabled) ? field.props.disabled : field.props.pageReadOnly
  field.props.isPureText = field.props.textShow ? field.props.textShow : pageType !== 'edit'
  field.follow = field && field.props?.follow === false  ? false : pageType !== 'edit'
  if (!field.rules) {
    field.rules = []
  }
  if (field.__targetType !== 'viewField') {
    field.rules = [...field.rules, ...getFieldRule(field)]
  }
  if (field.__targetType === 'viewField') {
    field.props.isPureText = true
  }
  if (parentPath) {
    field.__isUse = true
    insetField(_id, field, objectApiName, field.apiName)
  }
  if (field.mainField && field.props.isPureText) {
    field.fieldComponentName = 'jump'
    _initProps(field, 'jump')
  }

  // 是否是列表
  if (pageType === 'list') {
    field.viewComponentName = 'fast-field-render'
  }
}

// 摘要组字段处理  不合并props
function summary (field, {fieldMap}) {
  // TODO 摘要区内字段field 直接赋值不会更新fieldMap 需要单独更新
  // 摘要区内有默认值的字段保存时需要提交数据
  if (field?.defaultValue?.targetExpress) {
    fieldMap[field.apiName].__isUse = true
  }
  field.props = field.fieldConf || {}
  field.propsFn = field.summaryPropsFn || null
  field.props.isPureText = true
  field.props.span = 3
  field.props.supportBanner = 2
  _initProps(field, field._type)
  if (field.slots) {
    field.slots = {
      content: field.slots.summary
    }
  }
}

// 筛选组字段处理 不合并props
function search (field) {
  const filterPlaceholder = field.props?.filterPlaceholder
  field.props = {}
  field.propsFn = null
  field.props.isPureText = false
  _initProps(field, field._type)
  field.props.filterPlaceholder = filterPlaceholder
}

// // 字段组处理
// function fieldGroup (field) {
  
// }
